import Vue from 'vue';
import Vuex from 'vuex';
import campaign from './campaign';
import forms from './forms';
import legislators from './legislators';
import navigation from './navigation';
import advocate from './advocate';
import api from './api';
import tracking from './tracking';

Vue.use(Vuex);

const mod = {
    namespaced: true,
    modules: {
        campaign,
        forms,
        legislators,
        navigation,
        advocate,
        tracking,
        api
    }
};

export default new Vuex.Store(mod);
